import { connect } from 'react-redux';
import { getAgeRange, getAgeRangeFromQS } from '../../../modules/Filters';
import { getBase, getSearchType, getIsMobile } from '../../../modules/Settings';
import { buildNewQueryString } from '../../../app/helpers';
import { AgeRangeSelect } from './AgeRange';

const mapStateToProps = (state) => {
  // sort items to get min and max
  const sortedItems = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
  const hidden = false;
  const min = hidden ? 0 : sortedItems[0];
  const max = hidden ? 0 : sortedItems[sortedItems.length];
  return {
    ageRange: getAgeRange(state),
    min,
    max,
    ageRangeFromQS: getAgeRangeFromQS(state),
    base: getBase(state),
    searchType: getSearchType(state),
    isMobile: getIsMobile(state)
  };
};

const mapDispatchToProps = () => ({
  afterChangedValue: ({ v, push, min, max, ageRange, ageRangeFromQS, base: { pathname, qs } }) => {
    const newValue = v.join(',');
    const boundValue = [min, max].join(',');
    const hasAgeRangeOnQS = !!ageRangeFromQS;
    const actualValue = hasAgeRangeOnQS ? ageRangeFromQS : ageRange.join(',');
    const isInBoundValue = v[0] < min || v[1] > max;
    if (!((hasAgeRangeOnQS && (actualValue === newValue)) || !hasAgeRangeOnQS && newValue === boundValue) && !isInBoundValue) {
      push({
        pathname,
        search: buildNewQueryString('ageRange', newValue, qs),
        state: {
          notScroll: true
        }
      });
    }
    if (isInBoundValue) {
      push({
        pathname,
        search: buildNewQueryString('ageRange', boundValue, qs),
        state: {
          notScroll: true
        }
      });
    }
  }
});

 export const AgeRange = connect(mapStateToProps, mapDispatchToProps)(AgeRangeSelect);
 

